<template>
  <div class="pc_success-main" v-if="isMaxScreen">
    <img src="@/assets/PC/img/success.png" alt="" class="success-img" />
    <h5 class="title1">{{$t('components.successMain.647qmd42l1s0')}}</h5>
    <p>{{$t('components.successMain.647qmd42mss0')}}</p>
    <div class="product-info">
      <img :src="data.productLogo" alt="" class="product-info-img" />
      <div class="product-info-name-time">
        <span class="product-info-name">{{ data.skuName }}</span>
        <span class="product-info-time">{{ $t('components.successMain.orderTime') }}：{{ formatTime(data.orderCreatedDate) }}</span>
      </div>
      <div class="product-info-right">
        <span class="product-info-right-name">{{$t('components.successMain.647qmd42mz80')}}</span>
        <div class="product-info-right-price">
          <span class="coin">{{ data.currencySymbol }}</span>
          <span class="price">{{ Number(data.evaluation || 0) + Number(data.bonus || 0) + Number(data.expertDiscount || 0) }}</span>
        </div>
      </div>
    </div>
    <h5>{{$t('components.successMain.647qmd42yeo0')}}</h5>
    <div class="shipping">
      <div class="shipping-item shipping-item-bg1">
        <span class="shipping-item1">{{$t('components.successMain.text1')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text2')}}</span
        >
      </div>
      <div class="shipping-item shipping-item-bg2">
        <span class="shipping-item1">{{$t('components.successMain.text3')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text4')}}</span
        >
      </div>
      <div class="shipping-item shipping-item-bg3">
        <span class="shipping-item1">{{$t('components.successMain.text5')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text6')}}</span
        >
      </div>
    </div>
  </div>
  <div class="h5_success-main" v-else>
    <img src="@/assets/PC/img/success.png" alt="" class="success-img" />
    <h5>{{$t('components.successMain.647qmd42l1s0')}}</h5>
    <p>{{$t('components.successMain.647qmd42mss0')}}</p>
    <div class="product-info">
      <img :src="data.productLogo" alt="" class="product-info-img" />
      <div class="product-info-name-time">
        <div class="product-info-name">
          <div class="product-info-name-div">{{ data.skuName }}</div>
          <div class="product-info-right">
            <span class="product-info-right-name">{{$t('components.successMain.647qmd42mz80')}}:</span>
            <div class="product-info-right-price">
              <span class="coin">{{ data.currencySymbol }}</span>
              <span class="price">{{
                Number(data.evaluation || 0) + Number(data.bonus || 0) + Number(data.expertDiscount || 0)
              }}</span>
            </div>
          </div>
        </div>
        <span class="product-info-time">{{$t('components.successMain.orderTime')}}：{{ formatTime(data.orderCreatedDate) }}</span>
      </div>
    </div>
    <h5 class="notice">{{$t('components.successMain.647qmd42yeo0')}}</h5>
    <div class="shipping">
      <div class="shipping-item shipping-item-bg1">
        <span class="shipping-item1">{{$t('components.successMain.text1')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text2')}}</span
        >
      </div>
      <div class="shipping-item shipping-item-bg2">
        <span class="shipping-item1">{{$t('components.successMain.text3')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text4')}}</span
        >
      </div>
      <div class="shipping-item shipping-item-bg3">
        <span class="shipping-item1">{{$t('components.successMain.text5')}}</span>
        <span class="shipping-item2"
          >{{$t('components.successMain.text6')}}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from '@/utils/util'
export default {
  name: 'successMain',
  components: {},
  props: {
    data: Object
  },

  data() {
    return {};
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {
    goChooseModel() {
      if (this.notInvite) {
        this.$router.push('/choose_phone_model');
      } else {
        this.$router.push({
          name: 'choose_phone_model',
          params: {
            formPage: 'inviteEpIntroduce'
          }
        });
      }
    },
    formatTime(time){
      return formatDate(time, 'y-m-d-h-mm-s')
    }
  }
};
</script>

<style scoped lang="less">
@media (max-width: 980px) {
  .h5_success-main {
    display: flex;
    flex-direction: column;
    //   justify-content: center;
    align-items: center;
    // margin-bottom: 95px;
    .success-img {
      width: 400px;
      height: 320px;
      margin-top: 24px;
    }
    h5 {
      color: #252629;
      margin: 0;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 48px; /* 133.333% */
    }
    .notice {
      margin: 32px 0;
      text-align: left;
      width: 100%;
    }

    p {
      color: #666;
      text-align: justify;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 12px 24px;
    }

    .product-info {
      display: flex;
      width: 700px;
      height: 128px;
      // padding-right: 36px;
      // justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      border-radius: 4px;
      background: rgba(244, 244, 244, 0.5);

      margin-top: 32px;

      .product-info-img {
        width: 128px;
        height: 128px;
        margin-right: 16px;
      }
      .product-info-name-time {
        display: flex;
        flex: 1;
        flex-direction: column;
        .product-info-name {
          color: var(--text-1, #252629);
          font-family: 'PingFang SC';
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .product-info-name-div {
            width: 260px;
            white-space: nowrap; /* 文本不换行 */
            overflow: hidden; /* 隐藏溢出部分 */
            text-overflow: ellipsis; /* 显示省略号 */
          }
        }
        .product-info-time {
          color: var(--text-2, #5d5f65);
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          height: 25px;
          margin-top: 8px;
        }
      }

      .product-info-right {
        display: flex;
        align-items: center;
        margin-right: 16px;
        .product-info-right-name {
          color: var(--text-1, #252629);
          text-align: right;
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .product-info-right-price {
          display: flex;
          justify-content: flex-end;
          margin-left: 24px;
          .coin {
            color: #ff7b24;
            text-align: right;
            font-family: 'PingFang SC';
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }
          .price {
            color: #ff7b24;
            font-family: 'PingFang SC';
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }
        }
      }
    }

    .shipping {
      display: flex;
      flex-direction: column;
      margin-bottom: 36px;
      width: 100%;
      .shipping-item {
        height: 234px;
        padding: 23px 20px;
        // padding: 20px;
        // margin: 0 7px;
        border-radius: 4px;
        background: #f9f9f9;
        display: flex;
        //   align-items: center;
        flex-direction: column;
        // justify-content: center;
        margin-bottom: 24px;
        .shipping-item1 {
          color: var(--text-1, #252629);
          font-family: 'PingFang SC';
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 150%; /* 24px */
          margin-bottom: 20px;
          margin-left: 20px;
          margin-right: 20px;
        }
        .shipping-item2 {
          color: var(--text-2, #5d5f65);
          font-family: 'PingFang SC';
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin-left: 20px;
          margin-right: 20px;
        }
      }

      .shipping-item-bg1 {
        background-image: url(../../../assets/PC/img/icon1.png);
        background-size: 160px 160px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .shipping-item-bg2 {
        background-image: url(../../../assets/PC/img/icon2.png);
        background-size: 160px 160px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .shipping-item-bg3 {
        background-image: url(../../../assets/PC/img/icon3.png);
        background-size: 160px 160px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
    }
  }
}

@media (min-width: 981px) {
  .pc_success-main {
    display: flex;
    flex-direction: column;
    //   justify-content: center;
    align-items: center;
    margin-bottom: 36px;
    .success-img {
      width: 200px;
      height: 160px;
      margin-top: 70px;
    }
    .title1{
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 6px 0;
    }
    h5 {
      color: var(--text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 28px 24px;
    }
    p {
      color: var(--text-2, #5d5f65);
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      width: 640px;
      text-align: center;
    }

    .product-info {
      display: flex;
      width: 916px;
      height: 128px;
      padding-right: 36px;
      // justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      border-radius: 4px;
      background: rgba(244, 244, 244, 0.5);
      margin-top: 32px;

      .product-info-img {
        width: 128px;
        height: 128px;
        margin-right:20px ;
      }
      .product-info-name-time {
        display: flex;
        flex: 1;
        flex-direction: column;
        .product-info-name {
          color: var(--text-1, #252629);
          font-family: 'PingFang SC';
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          height: 34px;
        }
        .product-info-time {
          color: var(--text-2, #5d5f65);
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          height: 25px;
          margin-top: 8px;
        }
      }

      .product-info-right {
        display: flex;
        align-items: center;
        .product-info-right-name {
          color: var(--text-1, #252629);
          text-align: right;
          font-family: 'PingFang SC';
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .product-info-right-price {
          display: flex;
          justify-content: flex-end;
          margin-left: 24px;
          .coin {
            color: #ff7b24;
            text-align: right;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin-top: 12px;
          }
          .price {
            color: #ff7b24;
            font-family: 'PingFang SC';
            font-size: 40px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }
        }
      }
    }

    .shipping {
      display: flex;
      margin-bottom: 36px;
      .shipping-item {
        width: 260px;
        height: 100px;
        //   padding: 23px 20px;
        padding: 20px;
        margin: 0 7px;
        border-radius: 4px;
        background: #f9f9f9;
        display: flex;
        //   align-items: center;
        flex-direction: column;
        // justify-content: center;
        .shipping-item1 {
          color: var(--text-1, #252629);
          font-family: 'PingFang SC';
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 150%; /* 24px */
          display: block;
        }
        .shipping-item2 {
          color: var(--text-2, #5d5f65);
          font-family: 'PingFang SC';
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          display: block;
          margin-top: 10px;
        }
      }

      .shipping-item-bg1 {
        background-image: url(../../../assets/PC/img/icon1.png);
        background-size: 80px 80px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .shipping-item-bg2 {
        background-image: url(../../../assets/PC/img/icon2.png);
        background-size: 80px 80px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .shipping-item-bg3 {
        background-image: url(../../../assets/PC/img/icon3.png);
        background-size: 80px 80px;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
    }
  }
}
</style>
